<template>
  <v-dialog
      v-model="dialog"
      persistent
      width="500"
  >

    <template v-slot:activator="{ on }">
      <v-btn
          v-if="mode === 'create'"
          color="primary"
          v-on="on">
        <v-icon>mdi-plus</v-icon>
        Adicionar Cliente
      </v-btn>
      <v-btn
          v-else
          icon
          v-on="on">
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title
          class="headline green darken-2 white--text"
          primary-title
      >
        {{dialogTitle()}} Cliente
      </v-card-title>

      <v-card-text>
        <v-form
            ref="form"
            v-model="valid">

          <v-container>
            <v-layout>
              <v-flex xs4>
                <v-text-field
                    v-model="cpf"
                    :rules="requiredRules"
                    mask="###.###.###-##"
                    label="CPF"
                    required
                ></v-text-field>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                    v-model="name"
                    :rules="requiredRules"
                    label="Nome"
                    required
                />
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12>
                <v-text-field
                    v-model="email"
                    :rules="requiredRules"
                    label="E-mail"
                    required
                />
              </v-flex>
            </v-layout>
          </v-container>

        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-layout justify-space-between>
          <v-btn
              :disabled="loading"
              flat
              @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
              color="primary"
              flat
              :loading="loading"
              :disabled="!valid"
              @click="save()"
          >
            Salvar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import CustomerService from '@/services/applications/configurations/CustomerService';
  import * as cpfValidator from "@fnando/cpf";

  export default {
    name: 'CreateOrUpdate',
    props: ['customer', 'mode'],
    components: {},
    data() {
      return {
        id: '',
        name: '',
        cpf: '',
        email: '',
        loading: false,
        requiredRules: [
          v => !!v || 'Campo Obrigatório',
        ],
        cpfValidator,
        dialog: false,
        valid: false,
      };
    },
    methods: {
      save() {
        const payload = {
          id: this.id,
          name: this.name,
          email: this.email,
          cpf: this.cpf,
        };
        CustomerService
          .createOrUpdate(payload)
          .then(() => {
            this.$emit('loadPage');
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'success',
              message: `Cliente ${ this.snackBarMode() } com sucesso`,
              messageIcon: 'mdi-check',
            });
            this.dialog = false;
          })
          .catch(({ response }) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: response.data.join(', '),
              messageIcon: 'mdi-alert-circle',
            });
          });
      },
      dialogTitle() {
        return this.mode === 'create' ? 'Cadastrar' : 'Editar';
      },
      snackBarMode() {
        return this.mode === 'create' ? 'criado' : 'atualizado';
      }
    },
    watch: {
      dialog(newValue) {
        if (newValue) {
          if (this.customer !== null) {
            this.id = this.customer.id;
            this.name = this.customer.name;
            this.cpf = this.cpfValidator.format(this.customer.cpf);
            this.email = this.customer.email;
          }
        } else {
          this.$refs.form.reset();
        }
      },
    }
  };
</script>

<style scoped lang="scss">
</style>
